"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const Cell_vue_1 = __importDefault(require("../../../vue/Cell.vue"));
const summary_lib_1 = require("../../../js/summary_lib");
const provider_1 = require("../../../provider/provider");
// Block all slot editing features while showing cached data.
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTableEmployeeDateCellView',
    props: {
        userId: {
            type: Number,
            required: true,
        },
        dateString: {
            type: String,
            required: true,
        }
    },
    setup(__props) {
        const isReadOnly = (0, vue_3.inject)(provider_1.summaryTableIsReadOnlyInjectKey);
        const editModeProps = (0, vue_3.inject)(provider_1.summaryTableEditModePropsInjectKey);
        const cellsMap = (0, vue_3.inject)(provider_1.summaryTableCellsMapInjectKey);
        const meStore = (0, vue_3.inject)(provider_1.summaryTableMeStoreInjectKey);
        const slotMap = (0, vue_3.inject)(provider_1.summaryTableSlotMapInjectKey);
        const branchSettings = (0, vue_3.inject)(provider_1.summaryTableBranchSettingsInjectKey);
        const scrollContainer = (0, vue_3.inject)('scrollContainer', null);
        const cellApp = (0, vue_3.ref)(null);
        const summaryTablePresenter = (0, vue_3.inject)(provider_1.summaryTablePresenterInjectKey);
        const viewModel = (0, vue_3.inject)(provider_1.summaryTableViewModelInjectKey);
        const props = __props;
        const slotProps = (0, vue_3.computed)(() => {
            return cellsMap?.value[props.userId]?.[props.dateString]?.slots || {};
        });
        // Watch slot props and tell the child cell app to update.
        // The Cell Vue app cannot currently be altered to update itself.
        // The Shift page relies on a non-reactive version of cells map.
        (0, vue_3.watch)(() => slotProps, () => {
            cellApp.value?.updateSlots(slotProps.value);
        }, {
            deep: true,
        });
        const editModeCellProps = (0, vue_3.computed)(() => {
            if (!editModeProps) {
                return;
            }
            const allUsers = editModeProps.value[props.dateString];
            if (!allUsers) {
                return;
            }
            const thisCell = allUsers.find(u => u.userId === props.userId);
            if (!thisCell) {
                return;
            }
            return thisCell;
        });
        const isCellHovered = (0, vue_3.computed)(() => {
            if (!viewModel) {
                return false;
            }
            return viewModel.value.hoveredUserId === props.userId && viewModel.value.hoveredDate === props.dateString;
        });
        function handleSlotMount(e) {
            (0, summary_lib_1.addElToDroppable)(e.el);
        }
        function handleSlotUnmount(e) {
            (0, summary_lib_1.removeElFromDroppable)(e.el);
        }
        function handleCellHover(userId, date) {
            summaryTablePresenter?.handleCellHover(userId, date);
        }
        function handleCellHoverEnd() {
            summaryTablePresenter?.handleCellHoverEnd();
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Cell_vue_1.default, {
                ref_key: "cellApp",
                ref: cellApp,
                date: __props.dateString,
                "user-id": __props.userId,
                "slot-props": slotProps.value,
                "prev-user-id": editModeCellProps.value?.prevUserId,
                "next-user-id": editModeCellProps.value?.nextUserId,
                "prev-date": editModeCellProps.value?.prevDate,
                "next-date": editModeCellProps.value?.nextDate,
                "branch-settings": (0, vue_2.unref)(branchSettings),
                "slot-map": (0, vue_2.unref)(slotMap),
                "me-store": (0, vue_2.unref)(meStore),
                "is-used-in-shift-page": false,
                "is-staff-locked": false,
                "emit-slots-on-mount": true,
                "scroll-container": (0, vue_2.unref)(scrollContainer) || undefined,
                "is-read-only": (0, vue_2.unref)(isReadOnly),
                "is-cell-hovered": isCellHovered.value,
                onSlotMounted: handleSlotMount,
                onSlotUnmounted: handleSlotUnmount,
                onCellHover: handleCellHover,
                onCellHoverEnd: handleCellHoverEnd
            }, null, 8 /* PROPS */, ["date", "user-id", "slot-props", "prev-user-id", "next-user-id", "prev-date", "next-date", "branch-settings", "slot-map", "me-store", "scroll-container", "is-read-only", "is-cell-hovered"]));
        };
    }
});
